import React from 'react'
import { useTranslation } from 'react-i18next'
import { Plus } from 'lucide-react'

import { Button } from '@/components/ui/button'
import EmptyUser from '@/public/images/asset11.svg'

interface EmptyStateProps {
  onInviteClick: () => void
}

export const EmptyState: React.FC<EmptyStateProps> = ({ onInviteClick }) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <img src={EmptyUser} alt="No users" className="w-[120px] mb-6" />
      <div className="flex flex-col items-center">
        <span className="text-md font-semibold text-primary-900">
          {t('userManagement.empty.title')}
        </span>
        <p className="text-sm text-tertiary-600">
          {t('userManagement.empty.description')}
        </p>
        <Button onClick={onInviteClick} leadingIcon={<Plus size={20} />}>
          {t('userManagement.actions.inviteUser')}
        </Button>
      </div>
    </div>
  )
}
